
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6aa4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6aa4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ijXQL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5686d4bf53d3a45$export$2e2bcd8739ae039);
// Architecture explorer: <div data-arch="marketplace"></div> becomes a diagram
// drawn from scripts/arch-data.js. Selecting a component (click, or Tab then
// Enter) lights it and its connections and shows what it does; when the data
// has steps, a walkthrough below lights each step's components in turn.
// Plain SVG and DOM, no library. Works inside the case-study panel too.

var $i4xxr = parcelRequire("i4xxr");
const $d5686d4bf53d3a45$var$SVG = "http://www.w3.org/2000/svg";
const $d5686d4bf53d3a45$var$esc = (s)=>String(s).replace(/[&<>"]/g, (c)=>({
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;"
        })[c]);
const $d5686d4bf53d3a45$var$KIND_NAMES = {
    http: "HTTPS call (synchronous)",
    kafka: "Kafka event (asynchronous)",
    external: "Third-party API",
    discovery: "Service lookup",
    db: "Own database / index"
};
function $d5686d4bf53d3a45$var$el(name, attrs = {}, parent) {
    const node = document.createElementNS($d5686d4bf53d3a45$var$SVG, name);
    for (const [k, v] of Object.entries(attrs))node.setAttribute(k, v);
    if (parent) parent.appendChild(node);
    return node;
}
// A straight edge between two aligned nodes, from border to border
function $d5686d4bf53d3a45$var$straightPath(a, b) {
    if (Math.abs(a.x - b.x) < 1) {
        const down = b.y > a.y;
        const y1 = a.y + (down ? a.h / 2 : -a.h / 2);
        const y2 = b.y + (down ? -b.h / 2 : b.h / 2);
        return `M${a.x} ${y1} V${y2}`;
    }
    const right = b.x > a.x;
    const x1 = a.x + (right ? a.w / 2 : -a.w / 2);
    const x2 = b.x + (right ? -b.w / 2 : b.w / 2);
    return `M${x1} ${a.y} H${x2}`;
}
function $d5686d4bf53d3a45$var$list(title, items) {
    if (!items || !items.length) return "";
    return `<dt>${$d5686d4bf53d3a45$var$esc(title)}</dt><dd><ul>${items.map((i)=>`<li>${$d5686d4bf53d3a45$var$esc(i)}</li>`).join("")}</ul></dd>`;
}
function $d5686d4bf53d3a45$var$render(container, data) {
    const byId = Object.fromEntries(data.nodes.map((n)=>[
            n.id,
            n
        ]));
    const [vx, vy, vw, vh] = data.viewBox;
    const name = container.dataset.arch;
    container.classList.add("ax");
    container.innerHTML = `
    <div class="ax__stage">
      <div class="ax__scroll"></div>
    </div>
    <ul class="ax__legend" aria-label="Legend">
      ${[
        "http",
        "kafka",
        "external",
        "discovery",
        "db"
    ].filter((k)=>data.edges.some((e)=>e.kind === k)).map((k)=>`<li><svg width="34" height="10" aria-hidden="true"><line class="ax-edge ax-edge--${k}" x1="1" y1="5" x2="33" y2="5" /></svg>${$d5686d4bf53d3a45$var$esc($d5686d4bf53d3a45$var$KIND_NAMES[k])}</li>`).join("")}
    </ul>
    <div class="ax__picker" role="group" aria-label="Components"></div>
    <div class="ax__panel" aria-live="polite"></div>`;
    const scroll = container.querySelector(".ax__scroll");
    const panel = container.querySelector(".ax__panel");
    const picker = container.querySelector(".ax__picker");
    const svg = $d5686d4bf53d3a45$var$el("svg", {
        viewBox: `${vx} ${vy} ${vw} ${vh}`,
        class: "ax__svg",
        role: "group",
        "aria-label": `${data.title}: select a component to see its role and connections`
    });
    scroll.appendChild(svg);
    const defs = $d5686d4bf53d3a45$var$el("defs", {}, svg);
    for (const kind of [
        "http",
        "kafka",
        "external",
        "discovery"
    ]){
        const m = $d5686d4bf53d3a45$var$el("marker", {
            id: `ax-${name}-${kind}`,
            viewBox: "0 0 8 8",
            refX: "7",
            refY: "4",
            markerWidth: "7",
            markerHeight: "7",
            orient: "auto-start-reverse",
            class: `ax-arrow ax-arrow--${kind}`
        }, defs);
        $d5686d4bf53d3a45$var$el("path", {
            d: "M0 0.6 L7.4 4 L0 7.4 Z"
        }, m);
    }
    // Edges first, so the nodes cover their ends
    const edgeLayer = $d5686d4bf53d3a45$var$el("g", {
        class: "ax__edges"
    }, svg);
    const labelLayer = $d5686d4bf53d3a45$var$el("g", {
        class: "ax__labels",
        "aria-hidden": "true"
    }, svg);
    const edgeEls = {};
    for (const e of data.edges){
        const d = e.path || $d5686d4bf53d3a45$var$straightPath(byId[e.from], byId[e.to]);
        const path = $d5686d4bf53d3a45$var$el("path", {
            d: d,
            class: `ax-edge ax-edge--${e.kind}`,
            "data-edge": e.id
        }, edgeLayer);
        if (e.kind !== "db") {
            path.setAttribute("marker-end", `url(#ax-${name}-${e.kind})`);
            if (e.both) path.setAttribute("marker-start", `url(#ax-${name}-${e.kind})`);
        }
        edgeEls[e.id] = {
            path: path,
            edge: e
        };
    }
    const nodeLayer = $d5686d4bf53d3a45$var$el("g", {
        class: "ax__nodes"
    }, svg);
    const nodeEls = {};
    for (const n of data.nodes){
        const g = $d5686d4bf53d3a45$var$el("g", {
            class: `ax-node ax-node--${n.kind}`,
            "data-node": n.id,
            tabindex: "0",
            role: "button",
            "aria-pressed": "false",
            "aria-label": `${n.label}${n.sub ? ", " + n.sub : ""}`
        }, nodeLayer);
        $d5686d4bf53d3a45$var$el("rect", {
            x: n.x - n.w / 2,
            y: n.y - n.h / 2,
            width: n.w,
            height: n.h,
            rx: n.kind === "data" || n.kind === "infra" ? n.h / 2 : 8
        }, g);
        const t = $d5686d4bf53d3a45$var$el("text", {
            x: n.x,
            y: n.sub ? n.y - 3 : n.y + 1,
            class: "ax-node__label"
        }, g);
        t.textContent = n.label;
        if (n.sub) {
            const s = $d5686d4bf53d3a45$var$el("text", {
                x: n.x,
                y: n.y + 11,
                class: "ax-node__sub"
            }, g);
            s.textContent = n.sub;
        }
        nodeEls[n.id] = g;
        g.addEventListener("click", ()=>select({
                type: "node",
                id: n.id
            }));
        g.addEventListener("keydown", (ev)=>{
            if (ev.key === "Enter" || ev.key === " ") {
                ev.preventDefault();
                select({
                    type: "node",
                    id: n.id
                });
            }
        });
    }
    // Edge labels at the middle of their path, now that it is in the page
    for (const { path: path, edge: edge } of Object.values(edgeEls)){
        if (!edge.label) continue;
        const p = edge.lx ? {
            x: edge.lx,
            y: edge.ly + 5
        } : path.getPointAtLength(path.getTotalLength() / 2);
        const t = $d5686d4bf53d3a45$var$el("text", {
            x: p.x,
            y: p.y - 5,
            class: "ax-edge__label",
            "text-anchor": edge.anchor || "middle"
        }, labelLayer);
        t.textContent = edge.label;
    }
    // The same components as buttons: easier to reach on a phone
    for (const n of data.nodes.filter((n)=>n.label !== "MongoDB")){
        const b = document.createElement("button");
        b.type = "button";
        b.className = "ax__chip";
        b.dataset.node = n.id;
        b.textContent = n.label;
        b.setAttribute("aria-pressed", "false");
        b.addEventListener("click", ()=>select({
                type: "node",
                id: n.id
            }));
        picker.appendChild(b);
    }
    // On a narrow screen the drawing scrolls sideways: start at its centre,
    // where the entry point is
    requestAnimationFrame(()=>{
        scroll.scrollLeft = (scroll.scrollWidth - scroll.clientWidth) / 2;
    });
    // ---- walkthrough ----
    let steps = null;
    if (data.steps) {
        steps = document.createElement("section");
        steps.className = "ax-steps";
        steps.setAttribute("aria-label", "Purchase walkthrough");
        steps.innerHTML = `
      <div class="ax-steps__head">
        <h3 class="ax-steps__title">Follow a purchase</h3>
        <div class="ax-steps__nav">
          <button type="button" class="ax-steps__btn" data-dir="-1" aria-label="Previous step"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
          <span class="ax-steps__count" aria-live="polite"></span>
          <button type="button" class="ax-steps__btn" data-dir="1" aria-label="Next step"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
        </div>
      </div>
      <ol class="ax-steps__list">
        ${data.steps.map((s, i)=>`<li><button type="button" class="ax-steps__item" data-step="${i}" aria-pressed="false"><span>${i + 1}</span>${$d5686d4bf53d3a45$var$esc(s.title)}</button></li>`).join("")}
      </ol>
      <div class="ax-steps__card"></div>
`;
        container.appendChild(steps);
        steps.querySelectorAll("[data-step]").forEach((b)=>b.addEventListener("click", ()=>select({
                    type: "step",
                    i: Number(b.dataset.step)
                })));
        steps.querySelectorAll("[data-dir]").forEach((b)=>b.addEventListener("click", ()=>{
                const i = state?.type === "step" ? state.i + Number(b.dataset.dir) : 0;
                select({
                    type: "step",
                    i: Math.max(0, Math.min(data.steps.length - 1, i))
                });
            }));
    }
    let state = null;
    function light(nodes, edges) {
        const on = nodes.length > 0;
        svg.classList.toggle("is-focused", on);
        for (const [id, g] of Object.entries(nodeEls))g.classList.toggle("is-lit", nodes.includes(id));
        for (const [id, { path: path }] of Object.entries(edgeEls))path.classList.toggle("is-lit", edges.includes(id));
    }
    function select(next) {
        state = next;
        for (const [id, g] of Object.entries(nodeEls))g.setAttribute("aria-pressed", String(next?.type === "node" && next.id === id));
        picker.querySelectorAll("[data-node]").forEach((b)=>b.setAttribute("aria-pressed", String(next?.type === "node" && next.id === b.dataset.node)));
        steps?.querySelectorAll("[data-step]").forEach((b)=>b.setAttribute("aria-pressed", String(next?.type === "step" && next.i === Number(b.dataset.step))));
        if (!next) {
            light([], []);
            panel.innerHTML = `<p class="ax__hint">Select a component in the diagram or in the list to see what it does and what it talks to.</p>`;
            if (steps) {
                steps.querySelector(".ax-steps__count").textContent = `${data.steps.length} steps`;
                steps.querySelector(".ax-steps__card").innerHTML = `<p class="ax__hint">Step through a purchase, from the Buy button to a paid or cancelled order. Each step lights the components involved.</p>`;
            }
            return;
        }
        if (next.type === "node") {
            const n = byId[next.id];
            const edges = data.edges.filter((e)=>e.from === n.id || e.to === n.id);
            const near = new Set([
                n.id,
                ...edges.flatMap((e)=>[
                        e.from,
                        e.to
                    ])
            ]);
            light([
                ...near
            ], edges.map((e)=>e.id));
            panel.innerHTML = `
        <h3 class="ax__name">${$d5686d4bf53d3a45$var$esc(n.label)}${n.sub ? ` <span>${$d5686d4bf53d3a45$var$esc(n.sub)}</span>` : ""}</h3>
        <p>${$d5686d4bf53d3a45$var$esc(n.role)}</p>
        <dl class="ax__facts">
          <dt>Technologies</dt><dd>${$d5686d4bf53d3a45$var$esc(n.tech)}</dd>
          ${n.db ? `<dt>Data</dt><dd>${$d5686d4bf53d3a45$var$esc(n.db)}</dd>` : ""}
          ${$d5686d4bf53d3a45$var$list("Incoming", n.in)}
          ${$d5686d4bf53d3a45$var$list("Outgoing", n.out)}
          ${$d5686d4bf53d3a45$var$list("Events", n.events)}
          ${$d5686d4bf53d3a45$var$list("Details", n.details)}
        </dl>
        ${n.link ? `<a class="ax__link" href="${$d5686d4bf53d3a45$var$esc(n.link)}" target="_blank" rel="noopener noreferrer"><i class="fa fa-github" aria-hidden="true"></i> Source on GitHub</a>` : ""}`;
            if (steps) {
                steps.querySelector(".ax-steps__count").textContent = `${data.steps.length} steps`;
                steps.querySelector(".ax-steps__card").innerHTML = `<p class="ax__hint">Pick a step to follow the purchase again.</p>`;
            }
        } else {
            const s = data.steps[next.i];
            light(s.nodes, s.edges);
            panel.innerHTML = `<p class="ax__hint">Step ${next.i + 1} lights ${$d5686d4bf53d3a45$var$esc(s.who)} in the diagram. Select a component for its details.</p>`;
            steps.querySelector(".ax-steps__count").textContent = `Step ${next.i + 1} of ${data.steps.length}`;
            steps.querySelector(".ax-steps__card").innerHTML = `
        <p class="ax-steps__who">${$d5686d4bf53d3a45$var$esc(s.who)}</p>
        <h4>${next.i + 1}. ${$d5686d4bf53d3a45$var$esc(s.title)}</h4>
        <p>${$d5686d4bf53d3a45$var$esc(s.what)}</p>
        <dl class="ax__facts">
          <dt>Data</dt><dd>${$d5686d4bf53d3a45$var$esc(s.data)}</dd>
          <dt>What can go wrong</dt><dd>${$d5686d4bf53d3a45$var$esc(s.wrong)}</dd>
          <dt>How it's handled</dt><dd>${$d5686d4bf53d3a45$var$esc(s.handled)}</dd>
        </dl>`;
        }
    }
    // Escape or a click on empty space clears the selection
    svg.addEventListener("click", (ev)=>{
        if (!ev.target.closest(".ax-node")) select(null);
    });
    container.addEventListener("keydown", (ev)=>{
        if (ev.key === "Escape" && state) {
            ev.preventDefault(); // don't close the case-study panel along with it
            ev.stopPropagation();
            select(null);
        }
    });
    select(null);
}
function $d5686d4bf53d3a45$export$2e2bcd8739ae039(root = document) {
    for (const container of root.querySelectorAll("[data-arch]")){
        const data = (0, $i4xxr.ARCHITECTURES)[container.dataset.arch];
        if (data && !container.classList.contains("ax")) $d5686d4bf53d3a45$var$render(container, data);
    }
}

});
parcelRegister("i4xxr", function(module, exports) {

$parcel$export(module.exports, "ARCHITECTURES", () => $d2829db915c03c48$export$9947d2119ab04370);
// What the architecture explorers draw (scripts/arch.js). Every node, edge and
// step comes from the projects' code and docs, checked on 2026-10-18:
// - Marketplace: github.com/Abdelilah-99/market-place (README, PAYMENT_ORDER_FLOW.md,
//   @KafkaListener topics, GetwayConfig, ProductService.reserveStock)
// - Blog: github.com/Abdelilah-99/Coffe_House (SecurityConfig, controllers, compose)
// Don't add a component or a connection the code doesn't have.
//
// Coordinates are in the SVG's viewBox units; x/y is a node's centre.
// Edge kinds: http (synchronous HTTPS), kafka (asynchronous event), db (own
// database), discovery (service lookup), external (third-party API).
const $d2829db915c03c48$var$MP = "https://github.com/Abdelilah-99/market-place/tree/main/";
const $d2829db915c03c48$export$e524fb833078894f = {
    title: "Marketplace architecture",
    viewBox: [
        0,
        0,
        760,
        500
    ],
    nodes: [
        {
            id: "web",
            x: 380,
            y: 36,
            w: 150,
            h: 40,
            kind: "client",
            label: "Angular",
            sub: "served by Caddy",
            role: "The storefront: home, product pages, seller and admin dashboards, login and profile. Caddy serves the built app over HTTPS and forwards /api/* to the gateway.",
            tech: "Angular, TypeScript, RxJS, Caddy",
            in: [
                "Browsers over HTTPS"
            ],
            out: [
                "Gateway: every /api/* call, with the JWT in the Authorization header",
                "Stripe: the buyer is redirected to Stripe's hosted checkout page"
            ],
            details: [
                "Route guards keep seller and admin pages for logged-in users with the right role.",
                "Client-side checks (logged in, not your own product) are for UX only: the backend enforces prices and stock."
            ],
            link: $d2829db915c03c48$var$MP + "frontend"
        },
        {
            id: "gateway",
            x: 380,
            y: 126,
            w: 150,
            h: 42,
            kind: "edge",
            label: "Gateway",
            sub: "Spring Cloud Gateway",
            role: "The single entry point for the API. It verifies RSA-signed JWTs, passes the user's id and role to the services as headers, rate limits each IP and routes each path to a service found in Eureka.",
            tech: "Spring Cloud Gateway, WebFlux, reactive Redis, JWT, Actuator + Prometheus",
            in: [
                "Angular (through Caddy)"
            ],
            out: [
                "Users, Products, Media, Payments over HTTPS with a client certificate (mTLS)",
                "Redis for rate limiting",
                "Eureka to resolve lb://users, lb://products, lb://media, lb://payments"
            ],
            details: [
                "Rate limit: Redis token bucket, 5 requests per second with bursts of 10, keyed by client IP.",
                "Requests without a token go on as GUEST; the services decide what a guest may do.",
                "Identity headers come from the verified token, so a client can't choose another user's id."
            ],
            link: $d2829db915c03c48$var$MP + "gateway/gateway"
        },
        {
            id: "eureka",
            x: 130,
            y: 126,
            w: 130,
            h: 36,
            kind: "infra",
            label: "Eureka",
            sub: "service registry",
            role: "Netflix Eureka registry. The gateway and the four services register here by name, so routes say lb://products instead of a fixed host and port.",
            tech: "Spring Cloud Netflix Eureka",
            in: [
                "Registrations from the gateway and the users, products, media and payments services",
                "Lookups from the gateway"
            ],
            out: [],
            details: [
                "The registration arrows from each service are left out of the drawing to keep it readable."
            ],
            link: $d2829db915c03c48$var$MP + "eureka-server/eureka"
        },
        {
            id: "redis",
            x: 620,
            y: 126,
            w: 130,
            h: 36,
            kind: "infra",
            label: "Redis",
            sub: "rate-limit buckets",
            role: "Holds the gateway's token buckets for rate limiting. Nothing else: no sessions, cache or queues.",
            tech: "Redis",
            in: [
                "Gateway"
            ],
            out: [],
            details: [],
            link: $d2829db915c03c48$var$MP + "redis"
        },
        {
            id: "users",
            x: 95,
            y: 236,
            w: 130,
            h: 42,
            kind: "service",
            label: "Users",
            sub: "users-service",
            role: "Registration, login and JWT issuing (signed with an RSA private key), profiles, admin user management and user search.",
            tech: "Spring Boot, Spring Security, Gradle",
            db: "Its own MongoDB (user-mongodb)",
            in: [
                "Gateway"
            ],
            out: [
                "Kafka: create-, update- and remove-user-events; confirm- and delete-avatar-events",
                "OpenSearch: user search index",
                "MongoDB"
            ],
            details: [
                "Admin endpoints require ROLE_ADMIN; profile endpoints require a logged-in user."
            ],
            link: $d2829db915c03c48$var$MP + "users-service"
        },
        {
            id: "products",
            x: 285,
            y: 236,
            w: 130,
            h: 42,
            kind: "service",
            label: "Products",
            sub: "products-service",
            role: "Product catalog, ratings, seller and admin product workflows, product search, and stock: reserve, confirm and release.",
            tech: "Spring Boot, Spring Data MongoDB, Kafka",
            db: "Its own MongoDB (products-service-mongodb)",
            in: [
                "Gateway",
                "Payments: internal inventory calls over mTLS",
                "Kafka: user events, item-sold-events, product-search-sync-events"
            ],
            out: [
                "Kafka: product, image and search-sync events",
                "OpenSearch: product index",
                "MongoDB"
            ],
            details: [
                "Stock is reserved with one conditional MongoDB update: the quantity drops only if enough is left and this reservation id isn't already there, so two buyers can't both take the last unit.",
                "Reservation data is hidden from public product responses."
            ],
            link: $d2829db915c03c48$var$MP + "products-service"
        },
        {
            id: "media",
            x: 475,
            y: 236,
            w: 130,
            h: 42,
            kind: "service",
            label: "Media",
            sub: "media-service",
            role: "Uploads and serves product images and avatars, and deletes the ones nothing uses any more.",
            tech: "Spring Boot, Spring Content (filesystem storage)",
            db: "Its own MongoDB for metadata, files on a storage volume",
            in: [
                "Gateway (the /api/media prefix is stripped)",
                "Kafka: user, product, image and avatar events"
            ],
            out: [
                "MongoDB"
            ],
            details: [
                "Uploads that are never confirmed are removed after 60 minutes by a job that runs every 15 minutes."
            ],
            link: $d2829db915c03c48$var$MP + "media-service"
        },
        {
            id: "payments",
            x: 665,
            y: 236,
            w: 130,
            h: 42,
            kind: "service",
            label: "Payments",
            sub: "payments-service",
            role: "Creates Stripe Checkout sessions from a server-side price, keeps orders (PENDING, PAID, CANCELLED) and handles Stripe's signed webhooks.",
            tech: "Spring Boot, Maven, Stripe Java SDK, Kafka",
            db: "Its own MongoDB (payment_orders)",
            in: [
                "Gateway: checkout and my-orders",
                "Stripe: webhooks, checked with the Stripe-Signature header"
            ],
            out: [
                "Products: reserve, confirm and release stock over mTLS",
                "Stripe: Checkout sessions (the secret key stays on the server)",
                "Kafka: item-sold-events",
                "MongoDB"
            ],
            details: [
                "The browser sends only a product id and a quantity: the price comes from the products service.",
                "Order state changes are conditional (only from PENDING), so a repeated webhook changes nothing."
            ],
            link: $d2829db915c03c48$var$MP + "payments-service"
        },
        {
            id: "kafka",
            x: 380,
            y: 338,
            w: 700,
            h: 34,
            kind: "bus",
            label: "Kafka",
            sub: "events between services",
            role: "The asynchronous link between services: each service keeps its own database, and events keep their copies in step.",
            tech: "Apache Kafka with Zookeeper",
            in: [
                "Users, Products, Payments (producers)"
            ],
            out: [
                "Products and Media (consumers)"
            ],
            events: [
                "create-user-events: Users \u2192 Products, Media",
                "update-user-events: Users \u2192 Products",
                "remove-user-events: Users \u2192 Products, Media",
                "create- / remove-product-events: Products \u2192 Media",
                "confirm- / delete-image-events: Products \u2192 Media",
                "confirm- / delete-avatar-events: Users \u2192 Media",
                "product-search-sync-events: Products \u2192 its search indexer",
                "item-sold-events: Payments \u2192 Products"
            ],
            details: [],
            link: $d2829db915c03c48$var$MP + "kafka"
        },
        {
            id: "db-users",
            x: 95,
            y: 430,
            w: 110,
            h: 32,
            kind: "data",
            label: "MongoDB",
            sub: "users",
            role: "The users service's own database.",
            tech: "MongoDB",
            in: [
                "Users"
            ],
            out: [],
            details: []
        },
        {
            id: "search",
            x: 200,
            y: 470,
            w: 120,
            h: 32,
            kind: "data",
            label: "OpenSearch",
            sub: "search index",
            role: "Full-text search for products and users, with admin endpoints to rebuild the indexes.",
            tech: "OpenSearch (single node)",
            in: [
                "Users",
                "Products"
            ],
            out: [],
            details: [],
            link: $d2829db915c03c48$var$MP + "opensearch"
        },
        {
            id: "db-products",
            x: 305,
            y: 430,
            w: 110,
            h: 32,
            kind: "data",
            label: "MongoDB",
            sub: "products",
            role: "The products service's own database: products, ratings, stock reservations.",
            tech: "MongoDB",
            in: [
                "Products"
            ],
            out: [],
            details: []
        },
        {
            id: "db-media",
            x: 475,
            y: 430,
            w: 110,
            h: 32,
            kind: "data",
            label: "MongoDB",
            sub: "media",
            role: "Image and avatar metadata (the files live on a volume).",
            tech: "MongoDB",
            in: [
                "Media"
            ],
            out: [],
            details: []
        },
        {
            id: "db-payments",
            x: 665,
            y: 430,
            w: 110,
            h: 32,
            kind: "data",
            label: "MongoDB",
            sub: "payments",
            role: "Payment orders: product and price snapshot, buyer, status, Stripe session id.",
            tech: "MongoDB",
            in: [
                "Payments"
            ],
            out: [],
            details: [
                "Paid orders are kept 365 days and cancelled ones 30 days; pending orders are never deleted by the retention job."
            ]
        },
        {
            id: "stripe",
            x: 665,
            y: 36,
            w: 120,
            h: 36,
            kind: "external",
            label: "Stripe",
            sub: "hosted checkout",
            role: "Takes the card payment on Stripe's own page, then tells the payments service the outcome through a signed webhook.",
            tech: "Stripe Checkout, webhooks",
            in: [
                "Payments: creates a session",
                "The buyer's browser, redirected to pay"
            ],
            out: [
                "Payments: checkout.session.completed and checkout.session.expired webhooks"
            ],
            details: [
                "Card details never pass through the marketplace."
            ]
        },
        {
            id: "monitoring",
            x: 560,
            y: 470,
            w: 150,
            h: 32,
            kind: "infra",
            label: "Prometheus \xb7 Grafana",
            sub: "",
            role: "Scrapes metrics from the gateway and the users, products and media services, plus host, container and Kafka exporters; Grafana shows the dashboards. Disk alerts fire below 20% and 10% free.",
            tech: "Prometheus, Grafana, node-exporter, cAdvisor, kafka-exporter",
            in: [
                "Scrapes /actuator/prometheus over HTTPS (lines left out of the drawing)"
            ],
            out: [],
            details: [
                "The payment steps also emit Micrometer observations, without order or user ids as labels."
            ],
            link: $d2829db915c03c48$var$MP + "prometheus"
        }
    ],
    edges: [
        {
            id: "web-gateway",
            from: "web",
            to: "gateway",
            kind: "http",
            label: "HTTPS /api"
        },
        {
            id: "gateway-eureka",
            from: "gateway",
            to: "eureka",
            kind: "discovery",
            label: "lookup"
        },
        {
            id: "gateway-redis",
            from: "gateway",
            to: "redis",
            kind: "http",
            label: "rate limit"
        },
        {
            id: "gateway-users",
            from: "gateway",
            to: "users",
            kind: "http",
            label: "mTLS",
            path: "M380 147 V186 H95 V215"
        },
        {
            id: "gateway-products",
            from: "gateway",
            to: "products",
            kind: "http",
            path: "M380 147 V186 H285 V215"
        },
        {
            id: "gateway-media",
            from: "gateway",
            to: "media",
            kind: "http",
            path: "M380 147 V186 H475 V215"
        },
        {
            id: "gateway-payments",
            from: "gateway",
            to: "payments",
            kind: "http",
            path: "M380 147 V186 H665 V215"
        },
        {
            id: "payments-products",
            from: "payments",
            to: "products",
            kind: "http",
            label: "reserve \xb7 confirm \xb7 release",
            path: "M630 257 V292 H320 V257"
        },
        {
            id: "payments-stripe",
            from: "payments",
            to: "stripe",
            kind: "external",
            label: "session \xb7 webhook",
            lx: 712,
            ly: 178,
            anchor: "end",
            path: "M720 215 V54",
            both: true
        },
        {
            id: "web-stripe",
            from: "web",
            to: "stripe",
            kind: "external",
            label: "redirect to pay",
            path: "M455 36 H605"
        },
        {
            id: "users-kafka",
            from: "users",
            to: "kafka",
            kind: "kafka",
            path: "M75 257 V321"
        },
        {
            id: "products-kafka",
            from: "products",
            to: "kafka",
            kind: "kafka",
            path: "M265 257 V321",
            both: true
        },
        {
            id: "kafka-media",
            from: "kafka",
            to: "media",
            kind: "kafka",
            path: "M455 321 V257"
        },
        {
            id: "payments-kafka",
            from: "payments",
            to: "kafka",
            kind: "kafka",
            path: "M700 257 V321"
        },
        {
            id: "users-db",
            from: "users",
            to: "db-users",
            kind: "db",
            path: "M115 257 V414"
        },
        {
            id: "users-search",
            from: "users",
            to: "search",
            kind: "db",
            path: "M140 257 V380 H185 V454"
        },
        {
            id: "products-search",
            from: "products",
            to: "search",
            kind: "db",
            path: "M250 257 V380 H215 V454"
        },
        {
            id: "products-db",
            from: "products",
            to: "db-products",
            kind: "db",
            path: "M305 257 V414"
        },
        {
            id: "media-db",
            from: "media",
            to: "db-media",
            kind: "db",
            path: "M495 257 V414"
        },
        {
            id: "payments-db",
            from: "payments",
            to: "db-payments",
            kind: "db",
            path: "M665 257 V414"
        }
    ],
    // The purchase, step by step (PAYMENT_ORDER_FLOW.md). Each step lights its
    // nodes and edges in the drawing.
    steps: [
        {
            title: "The buyer clicks Buy",
            who: "Angular",
            nodes: [
                "web"
            ],
            edges: [],
            what: "The product page checks the buyer is logged in, then posts the product id and the quantity to /api/payments/checkout-sessions.",
            data: "{ productId, quantity }: no price, no buyer id.",
            wrong: "A modified browser tries to send a lower price.",
            handled: "There is no price to tamper with: the server takes it from the products service."
        },
        {
            title: "The gateway checks who is asking",
            who: "Gateway",
            nodes: [
                "web",
                "gateway",
                "redis",
                "eureka"
            ],
            edges: [
                "web-gateway",
                "gateway-redis",
                "gateway-eureka"
            ],
            what: "The gateway verifies the JWT's RSA signature, sets X-User-Id and X-User-Role from it, applies the Redis rate limit and routes /api/payments/** to the payments service found in Eureka.",
            data: "The JWT in; identity headers out.",
            wrong: "A forged or expired token, or a client sending requests in a loop.",
            handled: "Requests without a valid token don't get a user id, so checkout isn't possible; past 5 requests per second (bursts of 10) the IP gets 429 Too Many Requests."
        },
        {
            title: "Payments validates and picks an order id",
            who: "Payments",
            nodes: [
                "gateway",
                "payments"
            ],
            edges: [
                "gateway-payments"
            ],
            what: "The request is validated (a product id, a positive quantity) and a UUID is generated. The same id will be the order id and the stock reservation id.",
            data: "orderId == reservationId",
            wrong: "Missing product id, zero or negative quantity.",
            handled: "Bean Validation rejects it with 400 before anything is reserved."
        },
        {
            title: "Stock is reserved, atomically",
            who: "Products",
            nodes: [
                "payments",
                "products",
                "db-products"
            ],
            edges: [
                "payments-products",
                "products-db"
            ],
            what: "Over mTLS, payments asks the products service to reserve. One MongoDB findAndModify lowers the quantity and records the reservation, only if quantity \u2265 requested and this reservation id isn't already recorded.",
            data: "{ reservationId, productId, quantity } in; the product's name, price and image back.",
            wrong: "Two buyers race for the last unit, or the same request is retried.",
            handled: "The condition and the update happen in one document operation: only one buyer matches, the other gets 409 Conflict. A retried reservation id can't reserve twice."
        },
        {
            title: "A PENDING order is saved",
            who: "Payments",
            nodes: [
                "payments",
                "db-payments"
            ],
            edges: [
                "payments-db"
            ],
            what: "The order is stored as PENDING with a snapshot of the product name and price, and the buyer id from the gateway's header.",
            data: "PaymentOrder { id, productId, name, unitPrice, quantity, buyerId, status: PENDING }",
            wrong: "The database write fails after the stock is already reserved.",
            handled: "Compensation: the exact reservation is released, so the stock comes back once and only once."
        },
        {
            title: "Stripe Checkout session",
            who: "Payments \u2192 Stripe",
            nodes: [
                "payments",
                "stripe",
                "web"
            ],
            edges: [
                "payments-stripe",
                "web-stripe"
            ],
            what: "Payments creates a one-time Checkout session (30-minute expiry) with the server-side price and the order id as metadata, attaches the session id to the order and returns the hosted URL. The browser goes to Stripe to pay.",
            data: "Stripe session id and checkout URL back to the browser; the secret key never leaves the server.",
            wrong: "Stripe is unreachable or rejects the request.",
            handled: "Compensation again: the reservation is released and the order cancelled; the buyer gets 502 with a clear message."
        },
        {
            title: "Stripe's webhook decides",
            who: "Stripe \u2192 Payments",
            nodes: [
                "stripe",
                "payments"
            ],
            edges: [
                "payments-stripe"
            ],
            what: "When the buyer pays, Stripe calls /api/payments/webhooks/stripe. The payments service checks the Stripe-Signature against the webhook secret before trusting the event. The success page the buyer returns to changes nothing by itself.",
            data: "checkout.session.completed (or .expired), signed by Stripe.",
            wrong: "Someone posts a fake 'paid' event, or visits the success URL without paying.",
            handled: "Unsigned or altered events get 400. Only a verified webhook can move an order."
        },
        {
            title: "Sale event, then PAID",
            who: "Payments \u2192 Kafka \u2192 Products",
            nodes: [
                "payments",
                "kafka",
                "products",
                "db-payments",
                "db-products"
            ],
            edges: [
                "payments-kafka",
                "products-kafka",
                "payments-db",
                "products-db"
            ],
            what: "Payments publishes item-sold to Kafka and waits for the broker's acknowledgement, then moves the order from PENDING to PAID. The products service consumes the event and removes the reservation marker (the quantity was already lowered at step 4).",
            data: "item-sold-events { eventId = Stripe session id, reservationId, productId, quantity, buyerId }",
            wrong: "Kafka is down, or Stripe delivers the same webhook twice.",
            handled: "If Kafka doesn't acknowledge, the order stays PENDING and Stripe retries the webhook. A second delivery finds the order already PAID and no reservation to confirm, so nothing happens twice."
        },
        {
            title: "Or: the session expires",
            who: "Stripe \u2192 Payments \u2192 Products",
            nodes: [
                "stripe",
                "payments",
                "products",
                "db-products",
                "db-payments"
            ],
            edges: [
                "payments-stripe",
                "payments-products",
                "products-db",
                "payments-db"
            ],
            what: "If the buyer doesn't pay within 30 minutes, Stripe sends checkout.session.expired. Payments releases the exact reservation (quantity back up, marker removed in one update) and moves the order to CANCELLED.",
            data: "{ reservationId, productId, quantity } to release.",
            wrong: "The expiry webhook arrives twice.",
            handled: "The second release finds no matching reservation (a 404 treated as already done), so the stock isn't inflated."
        }
    ]
};
const $d2829db915c03c48$var$CH = "https://github.com/Abdelilah-99/Coffe_House/tree/main/";
const $d2829db915c03c48$export$949099781235e7db = {
    title: "Blog platform architecture",
    viewBox: [
        0,
        0,
        760,
        330
    ],
    nodes: [
        {
            id: "web",
            x: 380,
            y: 36,
            w: 160,
            h: 40,
            kind: "client",
            label: "Angular",
            sub: "frontend",
            role: "The app: feed with infinite scroll, post editor with images, profiles, notifications, admin panel.",
            tech: "Angular 20, TypeScript, RxJS, Bootstrap",
            in: [
                "Browsers over HTTPS"
            ],
            out: [
                "Backend: REST calls with the JWT"
            ],
            details: [
                "The token is decoded on the client only to show the right screens; the backend checks it on every request."
            ],
            link: $d2829db915c03c48$var$CH + "frontend"
        },
        {
            id: "security",
            x: 380,
            y: 120,
            w: 220,
            h: 42,
            kind: "edge",
            label: "Spring Security",
            sub: "stateless JWT filter",
            role: "Every request passes a JWT filter before reaching a controller. Sessions are stateless; /api/admin/** requires ROLE_ADMIN; login, register and uploaded files are public.",
            tech: "Spring Security, JJWT",
            in: [
                "Angular"
            ],
            out: [
                "The controllers"
            ],
            details: [
                "Passwords are hashed with BCrypt.",
                "Input sanitisation and file validation services check what users send."
            ],
            link: $d2829db915c03c48$var$CH + "backend/src/main/java/com/blog/config"
        },
        {
            id: "auth",
            x: 90,
            y: 210,
            w: 110,
            h: 36,
            kind: "service",
            label: "Auth",
            sub: "register \xb7 login",
            role: "Registration and login; issues the JWT.",
            tech: "Spring Boot",
            in: [
                "Security filter"
            ],
            out: [
                "PostgreSQL"
            ],
            details: []
        },
        {
            id: "posts",
            x: 235,
            y: 210,
            w: 120,
            h: 36,
            kind: "service",
            label: "Posts",
            sub: "comments \xb7 likes",
            role: "Posts with images, comments and likes; the feed uses cursor pagination (last time + last id) for infinite scroll.",
            tech: "Spring Boot, Spring Data JPA",
            in: [
                "Security filter"
            ],
            out: [
                "PostgreSQL",
                "Uploads volume"
            ],
            details: []
        },
        {
            id: "users",
            x: 380,
            y: 210,
            w: 120,
            h: 36,
            kind: "service",
            label: "Users",
            sub: "profiles \xb7 follows",
            role: "Profiles, follow and unfollow, followers and following lists, search.",
            tech: "Spring Boot, Spring Data JPA",
            in: [
                "Security filter"
            ],
            out: [
                "PostgreSQL"
            ],
            details: []
        },
        {
            id: "notifs",
            x: 525,
            y: 210,
            w: 120,
            h: 36,
            kind: "service",
            label: "Notifications",
            sub: "read \xb7 count",
            role: "When someone you follow publishes a post, you get a notification; the app fetches them, with an unread count.",
            tech: "Spring Boot",
            in: [
                "Security filter"
            ],
            out: [
                "PostgreSQL"
            ],
            details: []
        },
        {
            id: "admin",
            x: 670,
            y: 210,
            w: 120,
            h: 36,
            kind: "service",
            label: "Admin",
            sub: "reports \xb7 moderation",
            role: "Reports on users and posts, statistics, and moderation: ban or delete users, hide or delete posts.",
            tech: "Spring Boot",
            in: [
                "Security filter (ROLE_ADMIN only)"
            ],
            out: [
                "PostgreSQL"
            ],
            details: []
        },
        {
            id: "pg",
            x: 300,
            y: 296,
            w: 150,
            h: 34,
            kind: "data",
            label: "PostgreSQL 15",
            sub: "",
            role: "All relational data, through Spring Data JPA / Hibernate.",
            tech: "PostgreSQL 15 (Docker)",
            in: [
                "The backend"
            ],
            out: [],
            details: []
        },
        {
            id: "uploads",
            x: 500,
            y: 296,
            w: 150,
            h: 34,
            kind: "data",
            label: "Uploads",
            sub: "Docker volume",
            role: "Post images on a Docker volume, served by the backend.",
            tech: "Filesystem volume",
            in: [
                "Posts"
            ],
            out: [],
            details: []
        }
    ],
    edges: [
        {
            id: "web-security",
            from: "web",
            to: "security",
            kind: "http",
            label: "HTTPS + JWT"
        },
        {
            id: "s-auth",
            from: "security",
            to: "auth",
            kind: "http",
            path: "M380 141 V170 H90 V192"
        },
        {
            id: "s-posts",
            from: "security",
            to: "posts",
            kind: "http",
            path: "M380 141 V170 H235 V192"
        },
        {
            id: "s-users",
            from: "security",
            to: "users",
            kind: "http",
            path: "M380 141 V192"
        },
        {
            id: "s-notifs",
            from: "security",
            to: "notifs",
            kind: "http",
            path: "M380 141 V170 H525 V192"
        },
        {
            id: "s-admin",
            from: "security",
            to: "admin",
            kind: "http",
            path: "M380 141 V170 H670 V192"
        },
        {
            id: "auth-pg",
            from: "auth",
            to: "pg",
            kind: "db",
            path: "M90 228 V262 H270 V279"
        },
        {
            id: "posts-pg",
            from: "posts",
            to: "pg",
            kind: "db",
            path: "M235 228 V262 H285 V279"
        },
        {
            id: "users-pg",
            from: "users",
            to: "pg",
            kind: "db",
            path: "M380 228 V262 H315 V279"
        },
        {
            id: "notifs-pg",
            from: "notifs",
            to: "pg",
            kind: "db",
            path: "M525 228 V256 H330 V279"
        },
        {
            id: "admin-pg",
            from: "admin",
            to: "pg",
            kind: "db",
            path: "M670 228 V250 H345 V279"
        },
        {
            id: "posts-uploads",
            from: "posts",
            to: "uploads",
            kind: "db",
            path: "M255 228 V244 H500 V279"
        }
    ]
};
const $d2829db915c03c48$export$9947d2119ab04370 = {
    marketplace: $d2829db915c03c48$export$e524fb833078894f,
    blog: $d2829db915c03c48$export$949099781235e7db
};

});



//# sourceMappingURL=marketplace.bfa450ec.js.map
